// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
import '../public/css/main.css';
import Vue from 'vue';
import App from './App';
import router from './router';
import VueAnalytics from 'vue-analytics';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import Sticky from 'vue-sticky-directive';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueMoment from 'vue-moment';
import VueTheMask from 'vue-the-mask';
import Print from 'vue-print-nb';
import VueMeta from 'vue-meta';
const moment = require('moment');
require('moment/locale/tr');

// see docs for available options
const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
  daysShort: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts', 'Paz'],
  monthNames: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  colors: {
    selected: '#3785C7',
    inRange: '#a2b2d1',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#a2b2d1',
    disabled: '#fff',
    hoveredInRange: '#a2b2d1'
  },
  texts: {
    apply: 'Devam',
    cancel: 'İptal',
    keyboardShortcuts: 'Keyboard Shortcuts',
  },
}
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(VueNumberInput);
Vue.use(Sticky);
Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueTheMask);
Vue.use(Print);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueMeta);
Vue.use(VueAnalytics, {
  id: 'UA-60532739-1',
  router
});
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});
